<template>
  <v-app
    id="inspire"
    class="myFont"
  >
    <loading :overlay="$store.state.overlay"></loading>
    <v-app-bar
      app
      color="primary"
      elevation="5"
      fixed
    >
      <v-avatar
        tile
        width="165"
        height="55"
      >
        <img
          src="./assets/logo.png"
          alt="Kiosco Facturación"
        />
      </v-avatar>
      <v-spacer></v-spacer>
      <v-toolbar-title class="secondary--text hidden-sm-and-down">
        <span class="mx-2 pl-2">Kiosco de Autofacturación</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        class="secondary--text"
        to="/login"
      >
        <v-icon>mdi-alpha-r-box</v-icon>
      </v-btn>
      <v-btn
        icon
        class="secondary--text"
        to="/"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </v-app-bar>
    <div>
      <v-container
        fluid
        class="py-10"
      >

        <v-row v-if="!$store.state.issue">
          <v-col
            cols="12"
            md="5"
          >
            <router-view> </router-view>
          </v-col>
          <v-col
            v-if="!$store.state.issue"
            cols="12"
            md="7"
            class="hidden-sm-and-down mt-10"
          >

            <v-carousel
              height="auto"
              class="ma-20"
              cycle
            >
              <v-carousel-item
                v-for="(item, i) in items"
                :key="i"
                :src="item.src"
              ></v-carousel-item>
            </v-carousel>

          </v-col>
        </v-row>
        <v-row
          v-if="$store.state.issue"
          class="mb-4"
        >
          <v-col cols="12">
            <router-view> </router-view>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!--
    <v-footer
      fill-width
      color="primary"
      app
      absolute
    >
      <v-card
        flat
        tile
        width="100%"
        color="primary"
        class="text-center"
      >
        <v-card-text
          color="secondary"
          class="subtitle-2 secondary--text"
        >
          <strong>Desarrollado por Mysuite Services SA de CV</strong>
          <br />{{ new Date().getFullYear() }}
        </v-card-text>
      </v-card>
    </v-footer> -->
    <v-footer
      fill-width
      color="primary"
      app
      absolute
    >
      <v-card
        flat
        tile
        width="100%"
        color="primary"
        class="text-center"
      >
        <v-card-text>
          <v-btn
            v-for="icon in icons"
            :key="icon"
            class="mx-4 secondary--text"
            icon
          >
            <v-icon size="24px">
              {{ icon }}
            </v-icon>
          </v-btn>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="secondary--text">
          {{ new Date().getFullYear() }} — <strong>MYSUITE SERVICES SA de CV.</strong>
        </v-card-text>
      </v-card>
    </v-footer>

  </v-app>
</template>

<script>
import Loading from "./components/loading.vue";
export default {
  data: () => ({
    icons: ["mdi-twitter", "mdi-facebook", "mdi-instagram", "mdi-youtube"],
    items: [
      {
        src: "https://ccnatacion.azureedge.net/imgcar/1.jpg",
      },
      {
        src: "https://ccnatacion.azureedge.net/imgcar/2.jpg",
      },
      {
        src: "https://ccnatacion.azureedge.net/imgcar/3.jpg",
      },
    ],
  }),
  components: {
    Loading,
  },
  computed: {
    getNames() {
      if (this.$store.state.entity !== null) {
        return this.$store.state.entity.names;
      } else return "";
    },
    isAdministrator() {
      let result = false;
      if (this.$store.state.entity !== null) {
        result = this.$store.state.entity.role === "ADMINISTRADOR";
      }
      return result;
    },
  },
};
</script>
<style>
@font-face {
  font-family: "VAG Rounded";
  src: local("VAG Rounded"), url(./assets/VAGRoundedBold.ttf) format("truetype");
}

.myFont {
  font-family: "VAG Rounded", Helvetica, Arial;
}
</style>